(function () {
  function init(root) {
    if (root.hasAttribute('data-pdp-ready')) return;
    root.setAttribute('data-pdp-ready', '');

    var items = Array.prototype.slice.call(root.querySelectorAll('.faq-item'));

    // Questions after the first N start hidden only now that the script is running,
    // so with scripts off every question is still on the page.
    items.forEach(function (item) {
      if (item.hasAttribute('data-faq-extra')) item.classList.add('hidden');
    });

    function sync() {
      items.forEach(function (item) {
        var btn = item.querySelector('button.faq-question');
        if (btn) btn.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
      });
    }

    // One question open at a time. Clicking the open one closes it.
    items.forEach(function (item) {
      var btn = item.querySelector('button.faq-question');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('active');
        items.forEach(function (other) { other.classList.remove('active'); });
        if (!wasOpen) item.classList.add('active');
        sync();
      });
    });
    sync();

    // Questions after the first N sit behind a button that toggles Load More and Show less.
    var more = root.querySelector('.load-more-btn');
    var label = more && more.querySelector('.btn-label');
    var expanded = false;
    if (more && label) {
      more.addEventListener('click', function () {
        expanded = !expanded;
        items.forEach(function (item) {
          if (item.hasAttribute('data-faq-extra')) {
            item.classList.toggle('hidden', !expanded);
            if (!expanded) item.classList.remove('active');
          }
        });
        label.textContent = expanded ? more.getAttribute('data-less') : more.getAttribute('data-more');
        more.classList.toggle('is-open', expanded);
        sync();
      });
    }
  }

  function boot() { document.querySelectorAll('[data-pdp-faq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
